"use client"

import { memo, useState } from "react"

import styles from "../../index.module.scss"
import { useSuffix } from "../../SuffixContext"
import { AdComponentTypes, AdvertsType } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

function Expansion(props: AdComponentTypes) {
  const { AdList, style } = props
  const suffix = useSuffix()

  const [showLarge, setShowLarge] = useState(false)
  const [largeData, setLargeData] = useState<AdvertsType>()

  const onMouseHover = (item: AdvertsType) => {
    setLargeData(item)
    setShowLarge(true)
  }
  const onMouseLeave = () => {
    setShowLarge(false)
  }
  return (
    <div className={prefixCls}>
      <div className={styles.expansion} style={style}>
        {AdList.adverts.length > 0 && (
          <div
            className={styles.expansionBox}
            style={{
              height: AdList.width,
            }}
          >
            <ul className={styles.expansionUl}>
              {AdList.adverts.map((item) => {
                return (
                  <li key={item.id} className={styles.expansionLi} onMouseEnter={() => onMouseHover(item)}>
                    <a href={item.link_url} target="_blank" className={styles.expansionA} rel="noreferrer">
                      <img src={`${item.pic_url}${suffix || ""}`} alt={item.name} />
                      {item.is_inner == 0 && <div className={styles.expansionExtra}>AD</div>}
                      {item.post_count && <div className={styles.adPostNum}>{item.post_count}</div>}
                    </a>
                  </li>
                )
              })}
            </ul>
            {/* <!-- 扩充大图 --> */}
            {showLarge && (
              <div className={styles.largeImg} onMouseLeave={onMouseLeave}>
                <a
                  className={`${styles.largeAdvBox} ${styles.largeAdvBoxInner}`}
                  href={largeData?.link_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={largeData?.pic_url2}
                    alt={largeData?.name2}
                    style={{
                      width: AdList.len,
                      height: AdList.width,
                    }}
                  />
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
export default memo(Expansion)
